import styled from 'styled-components'

function SvgDiscountIcon(props) {
  return (
    <svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_942_9262)" fill="#24A850">
        <path d="M15.988 26.25L3.75 14.012v2.5c0 .663.263 1.3.737 1.763l9.738 9.738a2.505 2.505 0 003.537 0l7.763-7.763a2.505 2.505 0 000-3.538l-9.537 9.538z" />
        <path d="M14.225 21.762a2.505 2.505 0 003.537 0L25.526 14a2.505 2.505 0 000-3.537L15.788.725A2.55 2.55 0 0014.011 0H6.25a2.507 2.507 0 00-2.5 2.5v7.762c0 .663.263 1.3.737 1.763l9.738 9.737zM9.063 3.75a1.563 1.563 0 110 3.125 1.563 1.563 0 010-3.125z" />
      </g>
      <defs>
        <clipPath id="clip0_942_9262">
          <path fill="#fff" d="M0 0H30V30H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default styled(SvgDiscountIcon)``
